module.exports = __webpack_public_path__ + "img/icon-cup-3.08e40bb3.svg";